import { Navigate, Route, Routes } from 'react-router';
import { useTexts } from '@/feature/lang';
import { useIsRootRealmUser } from '@/feature/permissions/IsRootRealmUser';
import { DocumentTitle } from '@/view/app/routing/DocumentTitle';
import RmsRoutes from '@/view/rms/routes';
import AdminRoutes from './admin/routes';
import { NotFound } from './app/routing/NotFound';
import EcomRoutes from './ecom/routes';
import FleetRoutes from './fleet/routes';
import { adminPath, ecomPath, fleetPath, rmsPath } from './pathDefinitions';

export default function ViewRoutes() {
  const isRootRealmUser = useIsRootRealmUser();
  const redirectRoute = isRootRealmUser ? adminPath : fleetPath;
  const { app } = useTexts();

  return (
    <Routes>
      <Route path="/" element={<Navigate to={redirectRoute} replace />} />
      <Route path={`${fleetPath}/*`} element={<FleetRoutes />} />
      <Route path={`${ecomPath}/*`} element={<EcomRoutes />} />
      <Route path={`${adminPath}/*`} element={<AdminRoutes />} />
      <Route path={`${rmsPath}/*`} element={<RmsRoutes />} />
      <Route
        path="*"
        element={
          <>
            <DocumentTitle title={app.routing.notFound.title} />
            <NotFound />
          </>
        }
      />
    </Routes>
  );
}
